var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.f3c1cc7fb87842b4174f362db1f4b9b2.svg#X';
                    var viewUrl = 'sprites.f3c1cc7fb87842b4174f362db1f4b9b2.svg#view-X';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 115 66',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };